import { OpenService, type CommandContribution, type CommandRegistry } from '@patsnap/tahiti-core';
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { TaskExportService, type ExportOptions } from './task-export-service';

@injectable()
export class TaskExportContribution implements CommandContribution {
    constructor(
        @inject(TaskExportService)
        private readonly _taskExportService: TaskExportService,
        @inject(OpenService)
        private readonly _openService: OpenService,
    ) {

    }
    registerCommands(commands: CommandRegistry): void {
        commands.registerCommand({
            id: 'task:export',
        }, {
            execute: async (options: ExportOptions) => {
                const data = await this._taskExportService.exportTask(options);
                // 某点击事件，下载文件
                this._openService.open(data.url, { target: '_blank' });
            },
        });
    }
}


declare module '@patsnap/tahiti-core' {
    export interface CommandService {
        /**
         * 导出任务
         */
        executeCommand(commandId: 'task:export', options: ExportOptions): void;
    }
}
